/**
 * Single date format for the whole site: "2026.01.10."
 * Always Hungarian, independent of the visitor's browser locale.
 */
export function formatDate(value?: string): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date
    .toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit' })
    .replace(/\s/g, '');
}
